export const timeConstants = {
    errors: {
        fetchFailed: "Failed to load time data.",
        logFailed: "Failed to log time.",
        genericError: "Something went wrong.",
    },
    messages: {
        logSuccess: "Time logged successfully.",
    },
};
